import React, { useState, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import './PaginatedItems.scss';
import BoardList from './BoardList';
// import BoardListFaq from './BoardListFaq';
// import BoardDetail from './BoardDetail';
// import * as S from '../scss/theme';

import { useSelector, useDispatch } from 'react-redux';
import { setInitialPage } from "../reduxToolkit/reduxBoard";


function PaginatedItems({ items, itemsPerPage }) {

    const dispatch = useDispatch();

    const [itemOffset, setItemOffset] = useState(0);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    
    const [isNotice, setIsNotice] = useState(false);
    const [isBoard, setIsBoard] = useState(false);
    const [isFaq, setIsFaq] = useState(false);
    const [isGallery, setIsGallery] = useState(false);
    const [isVideo, setIsVideo] = useState(false);
    const [isLibray, setIsLibray] = useState(false);

    const endOffset = itemOffset + itemsPerPage;
    // const currentItems = items.slice(itemOffset, endOffset);
    // const pageCount = Math.ceil(items.length / itemsPerPage);
    const currentItems = (items || []).slice(itemOffset, endOffset);
    const pageCount = items ? Math.ceil(items.length / itemsPerPage) : 0;


    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage;
        setItemOffset(newOffset);
        dispatch(setInitialPage( event.selected));//paginate button number

    };

    const initialPage = useSelector(state => state.reduxStoreBoard.initialPage);
    const boardTitle = useSelector(state => state.reduxStoreBoard.boardTitle);
    // const boardKind = useSelector(state => state.reduxStoreBoard.boardKind);

  
    useEffect(() => {
     
        // setIsNotice(boardTitle.value === 'notice');
        setIsBoard(boardTitle.value === 'board');
        // setIsFaq(boardTitle.value === 'faq');
        // setIsLibray(boardTitle.value === 'libray');
    }, [boardTitle]);


    return (
        <>

        <div className={`paginate-container`}>
       
            <div className="ConTaIN">
       
                {/* <S.SubVisual className='subVisual'> */}
                    <div className='box_title'>
                        <h1>{boardTitle.text}</h1>
                    </div>
                {/* </S.SubVisual> */}
                <BoardList currentItems={currentItems} />

                {/* { (isNotice || isBoard || isLibray) && !isFaq  && <BoardList currentItems={currentItems}  /> }
                { (!isNotice || !isBoard || !isLibray) && isFaq  && <BoardListFaq currentItems={currentItems} /> }      */}

            </div>

            <ReactPaginate
                initialPage={initialPage}
                breakLabel={null}
                nextLabel={<i className="fas fa-chevron-right"></i>}
                onPageChange={handlePageClick}
                pageRangeDisplayed={4}
                marginPagesDisplayed={null}
                pageCount={pageCount}
                previousLabel={<i className="fas fa-chevron-left"></i>}
                renderOnZeroPageCount={null}
                containerClassName="pagination"
                activeClassName="active"
            />
        </div>

    </>

    );
}

export default PaginatedItems;
